import script from "./OrderConfirm.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderConfirm.vue?vue&type=script&setup=true&lang=ts"

import "./OrderConfirm.vue?vue&type=style&index=0&id=5df80f67&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5df80f67"]])

export default __exports__